import { isAfter, addDays, addWeeks, isValid } from 'date-fns';
import { createTraitsSelector } from '@atlassian/jira-traits/src/TraitsStore.tsx';

const isActiveInJiraFor7Days = (accountCreationDate: string) => {
	const date = new Date(accountCreationDate);
	if (!isValid(date)) {
		return false;
	}
	const today = new Date();

	return isAfter(today, addWeeks(date, 1));
};

const isInactiveInConfluenceFor28Days = (confluenceLastActiveDate: string) => {
	const date = new Date(confluenceLastActiveDate);
	if (!isValid(date)) {
		return false;
	}
	const today = new Date();

	return isAfter(today, addDays(date, 28));
};

// must first fetch the traits in the component before calling these hook

/**
 * Only return true if Jira account is at least 7 days old
 */
export const useIsJiraAccountAgeEligible = createTraitsSelector<'SITE_USER'>(
	'SITE_USER',
	({ getTraitByName }) => {
		const jiraFirstActiveDate = getTraitByName('jira_first_active')?.value;
		if (!jiraFirstActiveDate) return false;
		return typeof jiraFirstActiveDate === 'string' && isActiveInJiraFor7Days(jiraFirstActiveDate);
	},
);

/**
 * Only return true if user has been inactive in Confluence for at least 28 days
 */
export const useIsInactiveConfluenceUser = createTraitsSelector<'SITE_USER'>(
	'SITE_USER',
	({ getTraitByName }) => {
		const confluenceLastActiveDate = getTraitByName('confluence_last_active')?.value;
		return (
			typeof confluenceLastActiveDate === 'string' &&
			isInactiveInConfluenceFor28Days(confluenceLastActiveDate)
		);
	},
);

/**
 * Only return true if user has never been actived in Confluence
 */
export const useIsNewConfluenceUser = createTraitsSelector<'SITE_USER'>(
	'SITE_USER',
	({ getTraitByName }) => {
		const confluenceFirstActiveDate = getTraitByName('confluence_first_active')?.value;
		if (!confluenceFirstActiveDate) return true;
		return false;
	},
);

/**
 * Return true if user has not opened the Confluence search panel
 */
export const useHasNotInteractedWithNudge = createTraitsSelector<'SITE_USER'>(
	'SITE_USER',
	({ getTraitByName }) => {
		const hasOpenedPanelWithNudge = getTraitByName(
			'jira-platform_ui_panel_opened_crossproductsearchpanel_searchdialog_confluence_reactivation',
		)?.value;
		if (!hasOpenedPanelWithNudge) return true;
		return false;
	},
);
